import type { AnalyticsData } from "../types";
import { webEvent } from "./event";

const event = (name: string, data?: AnalyticsData) => webEvent("error_dialog", name, data);

// When a globalError is set (opening the error dialog)
export const errorDialogSeen = () => event("seen");

// When the user clicks the reload button in the error dialog
export const errorDialogReloadClicked = () => event("reload_clicked");

// When the user clicks the status link in the error dialog
export const errorDialogStatusLinkClicked = () => event("status_link_clicked");
